import React from 'react';
import {render} from 'react-dom';
import {FooterSection} from 'components/LandingPage';
import CarsHero from './CarsHero';
import CarsSeo from './CarsSeo';
import CarsSearchMask from './CarsSearchMask';
import PopularCompanies from './PopularCompanies';
import carStore from './store';
import {market, isoCurrency} from 'helpers/stableValues';
import {translations} from './translations';

const {searcMask, seo, popularCompanies} = carStore({market, currency: isoCurrency(), translations});

render((
  <div>
    <CarsHero {...searcMask}>
      <CarsSearchMask {...searcMask.data}/>
    </CarsHero>
    <PopularCompanies {...popularCompanies}/>
    <CarsSeo {...seo}/>
    <FooterSection/>
  </div>
), document.getElementById('carsLanding'));
